import type { KnockoutProps } from './Knockout.types';
import MatchGroup from './MatchGroup';

export default function Knockout(props: KnockoutProps) {
  const {
    rounds,
    roundIndex,
    finalMatch,
    thirdPlaceMatch,
    thirdPlaceLabel = '3rd Place',
    onRoundIndexChange,
  } = props;
  const clampedRoundIndex = Math.min(Math.max(roundIndex, 0), rounds.length);

  function renderMatchGroups() {
    if (clampedRoundIndex === rounds.length) {
      return (
        <MatchGroup
          firstMatch={finalMatch}
          thirdPlaceMatch={thirdPlaceMatch}
          onPreviousButtonClick={() => onRoundIndexChange(clampedRoundIndex - 1)}
          thirdPlaceLabel={thirdPlaceLabel}
          isPreviousButtonVisible
          isFinal
        />
      );
    }

    const round = rounds[clampedRoundIndex] ?? [];

    return round.map((matchGroup, index) => (
      <MatchGroup
        key={`${clampedRoundIndex}-${index}`}
        firstMatch={matchGroup[0]}
        secondMatch={matchGroup[1]}
        isPreviousButtonVisible={clampedRoundIndex > 0}
        isNextButtonVisible={clampedRoundIndex < rounds.length}
        onPreviousButtonClick={() => onRoundIndexChange(clampedRoundIndex - 1)}
        onNextButtonClick={() => onRoundIndexChange(clampedRoundIndex + 1)}
        thirdPlaceLabel={thirdPlaceLabel}
      />
    ));
  }

  return <div className="flex flex-col gap-2">{renderMatchGroups()}</div>;
}
